import React from 'react';
import { Download, FileText } from 'lucide-react';
import { Button } from '@roger/ui-components';
import type { MedicationProfileAttachmentResponse } from '../../services/api';
import DeleteAttachmentButton from './DeleteAttachmentButton';
import { formatDateForDisplay } from '../../utils/dateUtils';

interface AttachmentRowProps {
  attachment: MedicationProfileAttachmentResponse;
  onDownload: (attachment: MedicationProfileAttachmentResponse) => void;
  onDelete: (attachmentId: string) => Promise<void>;
}

const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const AttachmentRow: React.FC<AttachmentRowProps> = ({
  attachment,
  onDownload,
  onDelete,
}) => {
  return (
    <div className='flex items-center justify-between p-3 border rounded-lg'>
      <div className='flex items-center gap-3'>
        <FileText className='h-5 w-5 text-muted-foreground' />
        <div>
          <p className='font-medium text-sm'>{attachment.file_name}</p>
          <p className='text-xs text-muted-foreground'>
            {formatFileSize(attachment.file_size)} &middot;{' '}
            {formatDateForDisplay(attachment.uploaded_at)}
          </p>
        </div>
      </div>
      <div className='flex items-center gap-1'>
        <Button
          variant='ghost'
          size='sm'
          onClick={() => onDownload(attachment)}
        >
          <Download className='h-4 w-4' />
        </Button>
        <DeleteAttachmentButton onDelete={() => onDelete(attachment.id)} />
      </div>
    </div>
  );
};

export default AttachmentRow;
